import React from 'react';
import bg from '../../images/about-us/about-us-bg.webp'
import bgImg from '../../images/about-us/bg-img.webp'
import './AboutUs.css';
import Fade from 'react-reveal/Fade';
const AboutUs = () => {
    return (

        <div className="container about-us-block" id='AboutUs' style={{ backgroundImage: `url(${bgImg})`, backgroundSize: 'cover', width: '100%', borderRadius: '5px' }}>
            <div >
                <div className="row" >
                    <Fade bottom cascade>
                        <div className="about-us col-md-6"
                        >
                            <img className='w-100' src={bg} alt="" />
                        </div>
                    </Fade>
                    <Fade bottom cascade>
                        <div className="about-us col-md-6 d-flex align-items-center" >
                            <div>
                                <h1 className='text-center about-us-title'>About Us</h1>
                                <p className='text-center p-4 pt-0 about-us-paragraph'>
                                    Dry fruits have been a part of our diet and culture since times immemorial. We, nuts located in , provide roasted & salted almond, cashew, pistachios & raisin of premium quality. Our carefully chosen nuts & dry fruits are roasted, flavoured & packed in a state-of-the-art manner. We believe in gathering the best of nature & making it affordable to our customers.
                                </p>
                            </div>
                        </div>
                    </Fade>

                </div>
            </div>
        </div>
    );
};

export default AboutUs;